import { useState } from "react";

// Import a custom hook for permission access to check if the user is an Admin.
import { useIsAdmin } from "./authHooks";

export const useGaslinkMeterSearch = () => {
  // Check if the user is an Admin (AdminGlobal, AdminManager or AdminMember from Cognito user groups) to conditionally render the Address tab.
  const isAdmin = useIsAdmin();

  // The TS type of <'mprn' | 'address'> ensures that the activeTab useState is strictly limited to these values to prevent invalid values.
  const [activeTab, setActiveTab] = useState<"mprn" | "address">("mprn");

  return { isAdmin, activeTab, setActiveTab };
};
